module.exports = __webpack_public_path__ + "img/apply-success.7f48a919.png";